import React from "react";
import { Dialog, IconButton, Paper, Tooltip, styled } from "@mui/material";
import { Filled } from "../CopyLink";
import { CloudDownloadOutlined, QrCode } from "@mui/icons-material";
import { QRCodeCanvas } from "qrcode.react";
import { useTranslation } from "react-i18next";

interface QRCodeLinkProps {
  componentId: string;
  className?: string;
}
const PaperQR = styled(Paper)(({ theme }) => ({
  padding: "2.5rem",
  backgroundColor: theme.palette.common.white,
}));
const DownloadButton = styled(IconButton)(({ theme }) => ({
  position: "absolute",
  bottom: 0,
  left: "50%",
  transform: "translateX(-50%)",
  "& .MuiSvgIcon-root": {
    height: "2rem",
    width: "2rem",
  },
}));
const QRCodeLink = (props: QRCodeLinkProps) => {
  const { className = "" } = props;
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const { t } = useTranslation();

  const downloadQRCode = () => {
    const canvas = document.getElementById(
      "qrcode-canvas"
    ) as HTMLCanvasElement;
    let downloadLink = document.createElement("a");
    downloadLink.href = canvas
      .toDataURL("image/png")
      .replace("image/png", "image/octet-stream");
    downloadLink.download = `${props.componentId}.png`;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  };

  return (
    <>
      <Tooltip title={t("Create QR code")} arrow>
        <Filled onClick={handleOpen} className={`${className}`}>
          <QrCode />
        </Filled>
      </Tooltip>
      <Dialog open={open} onClose={handleClose}>
        <PaperQR>
          <QRCodeCanvas
            id="qrcode-canvas"
            size={384}
            value={window.location.href}
          />
        </PaperQR>
        <DownloadButton onClick={downloadQRCode}>
          <CloudDownloadOutlined color="info" />
        </DownloadButton>
      </Dialog>
    </>
  );
};

export default QRCodeLink;
